// test2385
(2385 && 0);
